import React, { FunctionComponent } from 'react'
import { ITitleProps } from './ITitle'
import { TitleStyles } from './Title.css'

const Title: FunctionComponent<ITitleProps> = ({ text, colour }) =>
  text ? <TitleStyles colour={colour}>{text}</TitleStyles> : null

export default Title
